/** In the app: a bar while the phone has no connection (the open page stays as it is) */
import { useEffect, useState } from 'react'
import { WifiOff } from 'lucide-react'
import { appBridge } from '../../lib/app/bridge'
import { useT } from '../../i18n'

export default function OfflineBar() {
  const t = useT()
  const [offline, setOffline] = useState(false)
  useEffect(() => appBridge()?.onNetwork(online => setOffline(!online)), [])
  if (!offline) return null
  return <div className="offline-bar" role="status"><WifiOff size={14} /> {t('auth.app.offline')}</div>
}
